var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-simple-context-menu',{ref:"vueContextMenuGroup",attrs:{"element-id":"contextMenuGroups","options":_vm.leftClickMenuOptions},on:{"option-clicked":_vm.optionClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }